import { render, staticRenderFns } from "./CompanySelector.vue?vue&type=template&id=a01c7b9a&scoped=true"
import script from "./companySelector.ts?vue&type=script&lang=ts&external"
export * from "./companySelector.ts?vue&type=script&lang=ts&external"
import style0 from "./CompanySelector.vue?vue&type=style&index=0&id=a01c7b9a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a01c7b9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a01c7b9a')) {
      api.createRecord('a01c7b9a', component.options)
    } else {
      api.reload('a01c7b9a', component.options)
    }
    module.hot.accept("./CompanySelector.vue?vue&type=template&id=a01c7b9a&scoped=true", function () {
      api.rerender('a01c7b9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/shared/explore/top-filter/company-selector/CompanySelector.vue"
export default component.exports